import { ref } from 'vue'

const STORAGE_KEY = 'convertToNewEmailDismissedAt'
const ONE_DAY_MS = 24 * 60 * 60 * 1000
const TWO_DAYS_MS = 2 * ONE_DAY_MS

class ConvertEmailService {
  constructor() {
    this.dismissedAt = ref(null)
  }

  /**
   * Initialize the service by loading the dismissed timestamp from localStorage.
   * Call this on app mount.
   */
  init() {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      const timestamp = parseInt(stored, 10)
      if (!isNaN(timestamp)) {
        this.dismissedAt.value = timestamp
      }
    }
  }

  /**
   * Check if the modal should be shown based on the dismiss state.
   * Returns true if:
   * - No dismiss timestamp exists, OR
   * - Dismiss timestamp is older than 24 hours, OR
   * - Dismiss timestamp is more than 2 days in the future (tampering - clears and shows)
   */
  shouldShow() {
    const now = Date.now()
    const timestamp = this.dismissedAt.value

    if (!timestamp) return true

    // If timestamp is more than 2 days in the future, clear it (manual tampering)
    if (timestamp > now + TWO_DAYS_MS) {
      this.clear()
      return true
    }

    // If timestamp is within the last 24 hours, hide the modal
    if (timestamp > now - ONE_DAY_MS) {
      return false
    }

    return true
  }

  /**
   * Dismiss the modal for 24 hours.
   * Sets the current timestamp in localStorage and the reactive ref.
   */
  dismiss() {
    const now = Date.now()
    this.dismissedAt.value = now
    localStorage.setItem(STORAGE_KEY, String(now))
  }

  /**
   * Clear the dismiss state.
   */
  clear() {
    this.dismissedAt.value = null
    localStorage.removeItem(STORAGE_KEY)
  }
}

export default new ConvertEmailService()
